import { useMemo } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Banner from "@/components/Banner";
import useAuthState from "@/hooks/useAuthState";
import { NAVBAR_ROUTES, ROUTES_PATH } from "@/router";
import { STATUS_BANNER_ROUTES } from "@/router/paths";

export default function RootLayout() {
  useAuthState();
  const { pathname } = useLocation();

  const { showNavBar, showStatusBanner } = useMemo(() => {
    const showNavBar = NAVBAR_ROUTES.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`),
    );
    const showStatusBanner = STATUS_BANNER_ROUTES.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`),
    );
    return { showNavBar, showStatusBanner };
  }, [pathname]);

  if (pathname === ROUTES_PATH.ROOT) {
    return <Navigate to={ROUTES_PATH.LOGIN} replace />;
  }
  return (
    <>
      {showNavBar && (
        <>
          <Navbar />
          {showStatusBanner && <Banner.AccessStatus />}
        </>
      )}
      <Outlet />
    </>
  );
}
